module.exports = {"id":"183855","name":"Angelo Ogbonna","rating":"78","photo":"./data/images/photos/2/183855.png","club":{"name":"West Ham Utd","logo":"./data/images/clubs/WestHamUtd.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AngeloOgbonna0.json
// module id = 419
// module chunks = 0